import { api, itemImageUploadDir } from '../config';

const SIZE_PREFIX = {
    medium: 'medium_',
    original: ''
};

// Item.image holds either an uploaded filename or an absolute URL (imported items).
export function getItemImageUrl(image, size = 'medium') {
    if (!image) return null;
    if (/^https?:\/\//i.test(image)) return image;

    return api.apiEndpoint + itemImageUploadDir + (SIZE_PREFIX[size] || '') + image;
}
